import axios from "../axios/index.js";

const urlGetRoomCustomer = "/api/room/get-list-customer-room";
const urlGetRoomTypeCustomer = "/api/room/get-list-room-type";
const urlRoomdetailCustomer = "/api/room/get-room-detail/";
const urlCreateNewViews = "api/loading";

export default {
    getListRoomCustomer(params) {
        return axios.post(urlGetRoomCustomer, params);
    },

    getListRoomType(params) {
        return axios.post(urlGetRoomTypeCustomer, params);
    },

    getRoomDetail(id) {
        return axios.post(urlRoomdetailCustomer + id);
    },
    
    createNewViews(params, config) {
        return axios.post(urlCreateNewViews, params, config);
    }
};
